import Vue from 'vue'
import Modal from './components/Modal'
import Minit from './components/Minit'
import Devolver from './components/Devolver'

// == STYLE
import 'normalize.css'
import '../src/styles/main.scss'

Vue.config.productionTip = false

// eslint-disable-next-line
let ocean = {
  container: null,
  width: null,
  height: null,
  array: [],
  count: 30
}

// == HELPERS
window.detectMobile = function() {
  let check = false
  // eslint-disable-next-line
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check
}

function repositionWave() {
  if (!this) return
  this.style.left = this.x + 'px'
  this.style.top = this.y + 'px'
  this.style.animationDelay = this.animationDelay + 's'
}

function destroyWave() {}

function getRandomNumberBetween(min, max) {
  return Math.floor(min + Math.random() * (max - min))
}

function findClosestNumberDivisibleBy(n, target) {
  return Math.round(target / n) * n
}

function Wave(target) {
  const min = 0
  const max = 15
  this.reposition = repositionWave
  this.destroy = destroyWave
  this.parent = target.container
  this.element = document.createElement('div')
  this.element.className = 'sprite wave'
  this.style = this.element.style
  // console.log('target w / h', target.width, target.height)
  const cols = findClosestNumberDivisibleBy(64, target.width)/64
  const rows = findClosestNumberDivisibleBy(64, target.height)/64
  const rCol = getRandomNumberBetween(0, cols)
  const rRow = getRandomNumberBetween(0, rows)
  this.x = rCol * 64
  this.y = rRow * 64
  // console.log('cols, rows', cols, rows)
  // console.log('rCol, rRow', rCol, rRow)
  // console.log('target pos', this.x, this.y)
  this.animationDelay = Math.floor(Math.random() * (max - min + 1)) + min
  this.reposition()
  this.parent.appendChild(this.element)
}

function makeWaves(target) {
  let c = target.count
  while (c--) {
    target.array[target.count] = new Wave(target)
    target.count++
  }
}

new Vue({
  el: '#app',
  components: { Minit, Devolver, Modal },
  filters: {
    twoDigits: function (value) {

      if(value.toString().length <= 1)
      {
        return "0"+value.toString()
      }
      return value.toString()
    }
  },
  // == DATA
  data() {
    return {
      debug: 0,
      scale: 4,
      showModal: false,
      date: Math.trunc(Date.parse('November 4, 2018 17:00:00 GMT-0500') / 1000),
      now: Math.trunc((new Date()).getTime() / 1000)
    }
  },
  computed: {
    minutesOnly() {
      return Math.trunc((this.date - this.now) / 60)
      // return 0
    },
    seconds() {
      return (this.date - this.now) % 60
    },
    minutes() {
      return Math.trunc((this.date - this.now) / 60) % 60
    },
    hours() {
      return Math.trunc((this.date - this.now) / 60 / 60) % 24
    },
    days() {
      return Math.trunc((this.date - this.now) / 60 / 60 / 24)
    }
  },
  // == LIFECYCLE
  mounted() {
    const vm = this
    this.$nextTick(() => { vm.setup() })
    // == SPIN UP OCEAN WAVES
    ocean.container = vm.$refs.waves
    ocean.width = ocean.container.clientWidth
    ocean.height = ocean.container.clientHeight
    makeWaves(ocean)
    window.setInterval(() => {
      this.now = Math.trunc((new Date()).getTime() / 1000)
    },1000)
  },
  methods: {
    goto: function (url, target) {
      const t = target ? target : '_self'
      window.open(url, t)
    },
    setup() {
      // eslint-disable-next-line
      const vm = this
    }
  }
})



// WEBPACK FOOTER //
// ./src/speedrun.js